// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as ActionsApiModel from "../api-model/ActionsApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function apiModelToState(res) {
  return {
          actions: List.map((function (data) {
                  return {
                          action_name: data.action_name,
                          action_comment_required: data.action_comment_required
                        };
                }), res.actions)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(ActionsApiModel.t_decode(json), "ActionsEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
